import { FC } from "react"
import { pageTitle$ } from "src/framework/store";

const About: FC = () => {
  pageTitle$.next("Sobre")


  return (
    <div>
      <h1>About</h1>
    </div>
  );
};

export { About };
